import React from 'react';

// A URL IN A COMMENT IS A LINK, not text to select and paste.
//
// Record comments carry download links now — a PEP extract's file, behind a short code on the sync API —
// and a comment rendered as plain text makes "click to download" a copy-and-paste exercise. The comment
// is otherwise untouched: this splits on URLs and wraps those, nothing else.
//
// ONLY http(s), deliberately. A comment is written by a lambda, but it is also editable by hand
// (RecordEditModal), so this must not turn arbitrary text into a live link scheme — `javascript:` most of
// all. Matching only the two schemes we ever write means the worst a pasted string can do is not become
// a link.
//
// `rel="noopener noreferrer"` and `target="_blank"`: the link leaves for S3, and an opened tab must not
// keep a handle on the portal's window.
//
// NEWLINES SURVIVE. Comments are multi-line (the OHIP call story is one line per exchange), so the
// wrapper preserves them rather than collapsing the comment into a paragraph.

// Trailing punctuation is excluded from the match: "see https://x.io/abc." should link the URL and leave
// the full stop as text, or the link 404s on a character somebody's grammar added.
const URL_RE = /(https?:\/\/[^\s<>"']+[^\s<>"'.,;:!?)\]}])/g;

const LinkifiedText = ({ text, className, title }) => {
    const value = text == null ? '' : String(text);
    if (!value) return null;

    const parts = value.split(URL_RE);

    return (
        <span className={className} title={title} style={{ whiteSpace: 'pre-wrap' }}>
            {parts.map((part, i) => (
                // split() with a capturing group puts the matches at the odd indices.
                i % 2 === 1 ? (
                    <a
                        key={i}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        style={{ color: '#2563eb', wordBreak: 'break-all' }}
                    >
                        {part}
                    </a>
                ) : (
                    <React.Fragment key={i}>{part}</React.Fragment>
                )
            ))}
        </span>
    );
};

export default LinkifiedText;
